export default "__VITE_ASSET__SaR6eJSy__"